import { getuserInfo } from '@/request/api/home.js';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      phone: '',
      password: ''
    };
  },

  computed: { ...mapState(['userid']),

    getuserid() {
      return JSON.parse(localStorage.getItem('userId'));
    }

  },
  methods: {
    login: async function () {
      let res = await this.$store.dispatch('getLogin', {
        phone: this.phone,
        password: this.password
      }); // console.log(res);

      if (res.data.code === 200) {
        this.$store.commit('updateisLogin', true);
        this.$store.commit('updatetoken', res.data.token);
        this.$store.commit('updateUserId', res.data.account.id); // console.log(this.userid);

        let result = await getuserInfo(this.getuserid); // console.log(result);

        this.$store.commit('updateUserInfo', result);
        this.$router.push('/center');
      } else {
        alert('手机号或密码错误');
      }
    }
  }
};